import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, loading, profileComplete, checkProfileComplete } = useAuth();
  const location = useLocation();

  useEffect(() => {
    // Check profile completion when route changes (except on profile page)
    if (isAuthenticated && location.pathname !== '/profile') {
      checkProfileComplete();
    }
  }, [isAuthenticated, location.pathname, checkProfileComplete]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Redirect to profile page if profile is incomplete (except if already on profile page)
  if (!profileComplete && location.pathname !== '/profile') {
    return <Navigate to="/profile" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;

